import { usePostMutation } from "../../../hooks/useClientPortalQuery";
import { useClientPortalConfigContext } from "../../../context";
import { DeleteFileRequest } from "../../../types/generated/models";
import { AxiosError } from "axios";

export interface IUseRemoveFile {
    removeFile: (request: DeleteFileRequest) => Promise<string>;
}

export function useRemoveFile(): IUseRemoveFile {
    const { clientPortalGuid } = useClientPortalConfigContext();

    const { mutateAsync } = usePostMutation<string, AxiosError, DeleteFileRequest>({
        url: `/api/v1/${clientPortalGuid}/File/DeleteClientFile`,
    });

    return {
        removeFile: mutateAsync,
    };
}
